export const columns = [
  {
    title: '呼出人',
    dataIndex: 'callerType',
    key: 'callerType',
    align: 'left',
    slots: {
      customRender: 'callerType'
    }
  },
  {
    title: '接听人',
    dataIndex: 'calleeName',
    key: 'calleeName',
    align: 'left',
    slots: {
      customRender: 'calleeName'
    }
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    align: 'left'
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    align: 'left'
  },
  {
    title: '电话时长',
    dataIndex: 'duration',
    key: 'duration',
    align: 'left',
    slots: {
      customRender: 'duration'
    }
  },
  {
    title: '通话状态',
    dataIndex: 'endStatusDesc',
    key: 'endStatusDesc',
    align: 'left',
    slots: {
      customRender: 'endStatusDesc'
    }
  },
  {
    title: '关联工单',
    dataIndex: 'action',
    key: 'action',
    align: 'left',
    slots: {
      customRender: 'action'
    }
  },
  {
    title: 'AI小结',
    dataIndex: 'chatSummaryStatus',
    align: 'left',
    customRender: ({ text }) => {
      const arr = ['生成失败', '已生成', '生成中'] //   0-失败 1-成功 2-生成中
      return arr[text]
    }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    align: 'left',
    slots: {
      customRender: 'operate'
    }
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
export const redTextStatus = [
  'unconnected',
  'ivrGiveUp',
  'noSeatOnline',
  'notAnswer',
  'userReject',
  'powerOff',
  'busy',
  'outOfCredit',
  'ivrEnd'
]
